<div class="reports-container">
  <div class="reports-header">
    <div class="header-content">
      <div class="header-icon">
        <mat-icon>assessment</mat-icon>
      </div>
      <div class="header-text">
        <h1>Reports</h1>
        <p>Generate and view comprehensive business reports</p>
      </div>
    </div>

    <div class="search-container">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        type="text"
        class="search-input"
        placeholder="Search reports..."
        [(ngModel)]="searchQuery"
      />
      <button class="clear-search" *ngIf="searchQuery" (click)="searchQuery = ''">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="reports-grid">
    <a *ngFor="let link of filteredReportLinks" [routerLink]="link.href" class="reports-card-link">
      <div class="reports-card" [class.featured-card]="link.featured">
        <div class="card-icon">
          <mat-icon>{{ link.icon }}</mat-icon>
        </div>
        <div class="card-content">
          <h3>{{ link.name }}</h3>
          <p>{{ link.description }}</p>
        </div>
        <div class="card-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>
    </a>

    <div class="no-results" *ngIf="filteredReportLinks.length === 0">
      <mat-icon>search_off</mat-icon>
      <p>No reports found matching "{{ searchQuery }}"</p>
    </div>
  </div>
</div>
